import { render } from "./RegisterCocomoniCheck.vue?vue&type=template&id=384b5b4e"
import script from "./RegisterCocomoniCheck.vue?vue&type=script&lang=js"
export * from "./RegisterCocomoniCheck.vue?vue&type=script&lang=js"

const cssModules = {}
import style0 from "./RegisterCocomoniCheck.vue?vue&type=style&index=0&id=384b5b4e&lang=scss&module=true"
cssModules["$style"] = style0

import exportComponent from "/usr/share/nginx/production/frontend/vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__cssModules',cssModules]])

export default __exports__